// Power plant management components
import { defineAsyncComponent } from 'vue'

export default {
  FallLeaseLandownerInfo: defineAsyncComponent(
    () => import('../power_plants/fall_lease_landowner_info.vue')
  ),
  PowerPlantEditButton: defineAsyncComponent(
    () => import('../power_plants/edit_button.vue')
  ),
  PowerPlantWindRose: defineAsyncComponent(
    () => import('../power_plant_wind_rose.vue')
  ),
  PowerPlantsAdminTable: defineAsyncComponent(
    () => import('../power_plants/admin_table.vue')
  ),
  PowerPlantsEditTable: defineAsyncComponent(
    () => import('../power_plants/edit_table.vue')
  ),
  WindEventMappings: defineAsyncComponent(
    () => import('../power_plants/form/wind/event_mappings.vue')
  ),
  WindPowerCurves: defineAsyncComponent(
    () => import('../power_plants/form/wind/power_curves.vue')
  ),
  ProductionSimulationPlanQueryButton: defineAsyncComponent(
    () => import('../production_simulation_plan/query_button.vue')
  )
}
